import {
  Get_Error,
  login,
  SignUp,
  Get_All_Users_log,
  Get_All_Users_log_forsearch,
  Get_One_USer,
  Update_One_USer_Main_Data,
  Change_Password_Type,
  team_leaders_type,
  Get_All_Users_log_forsearch_not_active,
  Logout_All_Users_And_Deactivate_Except_Admins,
  LogOutselecteduser_Type,
  Get_All_Users_Devices,
} from '../Types';

const intial = {
  Signup: [],
  get_one_user_array: [],
  oneuser: [],
  Change_Password_Array: [],
  loading: true,
  usersnotactive: [],
  logoutallusers: [],
  logoutselecteduser: [],
  // UsersDevices:[]
};

const Auth_Reducer = (state = intial, action) => {
  switch (action.type) {
    case SignUp:
      return {
        ...state,
        Signup: action.payload,
        loading: false,
      };
    case login:
      return {
        ...state,
        Signup: action.payload,
        loading: false,
      };
    case Get_All_Users_log_forsearch:
      return {
        Signup: action.payload,
        loading: false,
      };
    case Get_One_USer:
      return {
        get_one_user_array: action.payload,
        loading: false,
      };
    case Update_One_USer_Main_Data:
      return {
        oneuser: action.payload,
        loading: false,
      };
    case Change_Password_Type:
      return {
        Change_Password_Array: action.payload,
        loading: false,
      };
    case Get_All_Users_log_forsearch_not_active:
      return {
        usersnotactive: action.payload,
        loading: false,
      };
    case Logout_All_Users_And_Deactivate_Except_Admins:
      return {
        logoutallusers: action.payload,
        loading: false,
      };
    case LogOutselecteduser_Type:
      return {
        logoutselecteduser: action.payload,
        loading: false,
      };

    //  case Get_All_Users_Devices:
    //   return{
    // UsersDevices:action.payload,
    // loading:false,
    // }

    case Get_Error:
      return {
        loading: true,
        Signup: action.payload,
      };
    default:
      return state;
  }
};

export default Auth_Reducer;
